import { useLazyQuery } from '@apollo/client';
import React, { useEffect, useState, useCallback } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Form
} from 'reactstrap';
import { GET_RESCUE_PRODUCTS } from '../../../store/queries/cashbackReport';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../assets/css/override.css';
import '../../../assets/css/customDatePickerWidth.css';
import { ReportButtons } from '../../../components/Form/Button';
import SelectEmpresa from '../../../components/Select/SelectEmpresa';
import { formatFidelityType } from '../../../helpers/formatFidelityType';
import SelectProductPoints from '../../../components/Select/SelectProductPoints';
import DataTable from '../../../components/Table';
import {
  PopoverButton,
  PopoverContainer
} from '../../../components/Form/Popover';

const columnHead = [
  {
    title: 'Empresa',
    field: 'store',
    width: 300,
    cellStyle: { textAlign: 'left' },
    headerStyle: { textAlign: 'left' }
  },
  {
    title: 'Produto',
    field: 'product',
    cellStyle: { textAlign: 'left' },
    headerStyle: { textAlign: 'left' }
  },
  {
    title: 'Quantidade',
    field: 'quantity',
    cellStyle: { textAlign: 'right' },
    headerStyle: { textAlign: 'right' }
  },
  {
    title: 'Pontos',
    field: 'resumeValues',
    cellStyle: { textAlign: 'right' },
    headerStyle: { textAlign: 'right' }
  }
];

const formattedRows = data => {
  return data.map(item => ({
    totalRow: false,
    store: item.store,
    product: item.product,
    quantity: item.quantity,
    resumeValues: formatFidelityType(item.resumeValues, 'pt')
  }));
};

function RescueProductReport({ user }) {
  const [startDate, setStartDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [selectedProdutos, setSelectedProdutos] = useState([]);
  const [showWithdrawnProducts, setShowWithdrawnProducts] = useState(false);

  const [rows, setRows] = useState([]);
  const [selectedEmpresas, setSelectedEmpresas] = useState([]);
  const [getReport, { loading }] = useLazyQuery(GET_RESCUE_PRODUCTS, {
    fetchPolicy: 'network-only'
  });

  const handleConfirm = useCallback(async () => {
    const variables = {
      customer: user.customer,
      stores:
        selectedEmpresas
          .filter(item => item.type === 'store')
          .map(item => item.value) || null,
      gasstations:
        selectedEmpresas
          .filter(item => item.type === 'gasstation')
          .map(item => item.value) || null,
      products: selectedProdutos.map(item => item.value) || null,
      startDate,
      endDate,
      showWithdrawnProducts
    };

    const { data } = await getReport({ variables });

    if (data && data.getRescueProduct && data.getRescueProduct.length > 0) {
      const formatData = formattedRows(data.getRescueProduct[0].details);
      const rowsWithTotals = [
        ...formatData,
        {
          store: 'Total',
          product: '',
          quantity: data.getRescueProduct[0].totals.quantity,
          resumeValues: formatFidelityType(
            data.getRescueProduct[0].totals.resumeValues,
            'pt'
          ),
          totalRow: true
        }
      ];

      setRows(rowsWithTotals);
    } else {
      setRows([]);
    }
  }, [
    endDate,
    getReport,
    selectedEmpresas,
    selectedProdutos,
    startDate,
    user.customer,
    showWithdrawnProducts
  ]);
  const setCancel = () => {};

  useEffect(() => {
    const getReportData = async () => {
      if (user) {
        const { data } = await getReport({
          variables: {
            customer: user.customer,
            startDate,
            endDate,
            store: null,
            showWithdrawnProducts
          }
        });
        if (data.getRescueProduct.length > 0) {
          const formatData = formattedRows(data.getRescueProduct[0].details);
          const rowsWithTotals = [
            ...formatData,
            {
              store: 'Total',
              product: '',
              quantity: data.getRescueProduct[0].totals.quantity,
              resumeValues: formatFidelityType(
                data.getRescueProduct[0].totals.resumeValues,
                'pt'
              ),
              totalRow: true
            }
          ];

          setRows(rowsWithTotals);
        }
      }
    };
    getReportData();
  }, [showWithdrawnProducts]);

  return (
    <div className=''>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <Form>
                <Row>
                  <Col lg={3}>
                    <FormGroup>
                      <Label for='dataInicio'>
                        {showWithdrawnProducts
                          ? 'Data Inicial de Retirada *'
                          : 'Data Inicial de Processamento *'}
                      </Label>
                      <Input
                        value={startDate}
                        type='date'
                        name='dataInicio'
                        onChange={e => setStartDate(e.target.value)}
                        id='dataInicio'
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={3}>
                    <FormGroup>
                      <Label for='dataFim'>
                        {showWithdrawnProducts
                          ? 'Data Final de Retirada *'
                          : 'Data Final de Processamento *'}
                      </Label>
                      <Input
                        value={endDate}
                        type='date'
                        name='dataFim'
                        onChange={e => setEndDate(e.target.value)}
                        id='dataFim'
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={3}>
                    <SelectEmpresa
                      label='Empresas'
                      ismulti
                      customer={{ value: user.customer }}
                      parentCallback={setSelectedEmpresas}
                      value={selectedEmpresas}
                      placeholder='Selecione a(s) empresa(s)...'
                    />
                  </Col>
                  <Col lg={3}>
                    <SelectProductPoints
                      label='Produto'
                      ismulti
                      customer={{ value: user.customer }}
                      parentCallback={setSelectedProdutos}
                      value={selectedProdutos}
                      placeholder='Selecione o(s) produto(s)...'
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={4}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type='checkbox'
                          checked={showWithdrawnProducts}
                          onChange={e =>
                            setShowWithdrawnProducts(e.target.checked)
                          }
                        />
                        Mostrar apenas produtos retirados
                      </Label>
                      <PopoverButton id='PopoverWithdrawnProducts' size={16} />
                      <PopoverContainer id='PopoverWithdrawnProducts'>
                        <p>
                          Ao habilitar esta opção, o filtro de data considerará
                          a data em que o produto foi retirado, e não a data do
                          resgate.
                        </p>
                      </PopoverContainer>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col lg={8}>
                    <ReportButtons
                      onCancel={setCancel}
                      onConfirm={() => handleConfirm()}
                    />
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Card>
        <CardBody>
          <DataTable
            rows={rows}
            rowHead={columnHead}
            title={'Relatório de Produtos Resgatados'}
            loading={loading}
            searchInput
            showPagination={false}
            showTitle={false}
            showShadow={false}
            showExportButton
          />
        </CardBody>
      </Card>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(RescueProductReport);
